import { render, staticRenderFns } from "./AdminJournalReceivedSearch.vue?vue&type=template&id=b0366ca8&"
import script from "./AdminJournalReceivedSearch.vue?vue&type=script&lang=js&"
export * from "./AdminJournalReceivedSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports